<cloud-app-info></cloud-app-info>

<mat-sidenav-container>

  <mat-sidenav #sidenav mode="push">

    <div class="branding">
      <img [src]="logo" />
    </div>

    <mat-nav-list>
      <a mat-list-item *ngFor="let item of navigationSideMenu" (click)="sidenav.close()" [routerLink]="[item.link]"
        routerLinkActive="active">
        {{item.label | translate}}
      </a>
    </mat-nav-list>

  </mat-sidenav>

  <div class="wrapper">
    <cloud-app-nav [navElements]="navigation" [logo]="logo" [sidenav]="sidenav"></cloud-app-nav>
    <span *ngIf="showEmergencyTitle" class="emergency-title" matTooltip="{{'auth.emergencyLogin.titleDescrition.tooltip' | translate}}">
        {{'auth.emergencyLogin.title' | translate}}
    </span>
    <div class="content" [@routeAnimations]="o.isActivated && o.activatedRoute.routeConfig.path">

      <router-outlet #o="outlet"></router-outlet>
    </div>

    <cloud-app-footer></cloud-app-footer>

  </div>

</mat-sidenav-container>
